import React from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";
import { EventBetsViewState } from "@state/stores/my-bets/MyBetsViewStore";
import { Pager } from "@components-shared/mobile/inputs";

export const PagerWrapper = observer(function PagerWrapper({
	eventBetsState,
}: {
	eventBetsState: EventBetsViewState;
}) {
	const { myBetsViewStore } = useRootAppStore();

	return (
		<Pager
			pageNumber={eventBetsState.pageNumber}
			pageSize={myBetsViewStore.pageSize}
			totalItems={eventBetsState.totalItems}
			onPageChange={(page: number) =>
				myBetsViewStore.setEventPageNumber(eventBetsState.eventId, page)
			}
			withDropdown
		/>
	);
});
